var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M1.293,11.293L9,3.586L10.414,5l-6,6H22c0.553,0,1,0.448,1,1s-0.447,1-1,1H4.414l6,6L9,20.414l-7.707-7.707 C0.902,12.316,0.902,11.684,1.293,11.293z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }